import { AsyncComponent, ConfiguredComponents } from "@r-and-a-shared-ui/core-component-config";
import { IContentItem } from "@kontent-ai/delivery-sdk";

export interface RichTextMembershipProps {
  richTexts?: IContentItem[];
}

export function RichTextMembership({
  richTexts,
}: RichTextMembershipProps) {
  if (!richTexts) {
    return undefined;
  }

  return (
    <>
      {richTexts.map((richText, i) => (
        <AsyncComponent
          key={i}
          kontentItem={richText}
          contentType={richText?.system?.type as ConfiguredComponents}
        />
      ))}
    </>
  );
}

export default RichTextMembership;